import { updateDefaultStyleMaster } from '../../defaultStyleMaster/defaultStyleMaster.actions';
import {
    CREATE_COMMON_PROPERTY_FAILURE,
    CREATE_COMMON_PROPERTY_REQUEST,
    CREATE_COMMON_PROPERTY_SUCCESS,
    CREATE_USER_FORM_COMMON_PROPERTY,
    COMMON_PROPERTY_USERFORM_RESET,
    FETCH_COMMON_PROPERTY_BY_ID_REQUEST,
    FETCH_COMMON_PROPERTY_BY_ID_SUCCESS,
    FETCH_COMMON_PROPERTY_BY_ID_FAILURE,
    CREATE_COMMON_FEEDBACK_REQUEST,
    CREATE_COMMON_FEEDBACK_SUCCESS,
    CREATE_COMMON_FEEDBACK_FAILURE,
    CREATE_COMMON_FEEDBACK_FORM,
    COMMON_FEEDBACK_USERFORM_RESET,
    SET_SINGLE_ROW_CLICK_ID,
    RESET_SINGLE_ROW_CLICK_ID,
    CREATE_COMMON_STYLE_REQUEST,
    CREATE_COMMON_STYLE_SUCCESS,
    CREATE_COMMON_STYLE_FAILURE,
    CREATE_USER_FORM_COMMON_STYLE,
    COMMON_STYLE_USERFORM_RESET,
    CREATE_COMMON_FORMAT_REQUEST,
    CREATE_COMMON_FORMAT_FAILURE,
    CREATE_USER_FORM_COMMON_FORMAT,
    COMMON_FORMAT_USERFORM_RESET,
    CREATE_COMMON_FORMAT_SUCCESS,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS,
    FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE,
    COMMON_APPROVALMAIL_USERFORM,
    APP_LOGOUT_REQUEST,
    APP_LOGOUT_FAILURE,
    APP_LOGOUT_SUCCESS,
    SET_FORCE_LOGOUT_VAR,
    APP_FORCE_LOGOUT_REQUEST,
    APP_FORCE_LOGOUT_SUCCESS,
    APP_FORCE_LOGOUT_FAILURE
} from './commonProperty.actionsType';

export const COMMON_PROPERTY = 'commonProperty';

let initialState = {
    loading: false,
    isForceLogout: false,
    commonPropertyUserform: {},
    commonStyleUserform: {},
    commonFormatUserform: {},
    ageList: [],
    anyOfPropertyData: [],
    marketList: [],
    currencyList: [],
    typeOfOrder: [],
    typeOfPacking: [],
    unitOfMeasurement: [],
    generalheader: [],
    generalItem: [],
    accessoriesName: [],
    size: [],
    sleeveType: [],
    printType: [],
    neckList: [],
    typeOfFit: [],
    yarnList: [],
    MultiList: [],
    fabricList: [],
    typeOfPO: [],
    source: [],
    department: [],
    deliveryAt: [],
    agentName: [],
    millName: [],
    diaList: [],
    partNameList: [],
    catalogueNameList: [],
    modeOfPayment: [],
    genderList: [],
    accTypeList: [],
    paymentToBeDoneTo: [],
    productType: [],
    prodCategory: [],
    dyeingProgram: [],
    dyeingProcess: [],
    pimProgramList: [],
    colorShadeList: [],
    yarnMaterial: [],
    commonFeedbackform: {},
    singleRowData: {},
    errorMessage: '',
    approvalmail: {},
    paymentTerms: [],
    LotItem: [],
    adminCategory: [],
    companyList: []
};

export let commonPropertyReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_COMMON_PROPERTY_REQUEST:
        case CREATE_COMMON_STYLE_REQUEST:
        case CREATE_COMMON_FORMAT_REQUEST:
        case FETCH_COMMON_PROPERTY_BY_ID_REQUEST:
        case FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST:
        case CREATE_COMMON_FEEDBACK_REQUEST:
        case APP_LOGOUT_REQUEST:
        case APP_FORCE_LOGOUT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_COMMON_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                commonPropertyUserform: {}
            };
        case CREATE_COMMON_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                commonStyleUserform: {}
            };
        case CREATE_COMMON_FORMAT_SUCCESS:
            return {
                ...state,
                loading: false,
                commonFormatUserform: {}
            };
        case FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                anyOfPropertyData: updatePayload
            };
        case FETCH_COMMON_PROPERTY_BY_ID_SUCCESS:
            switch (payload) {
                case 8:
                    return {
                        ...state,
                        loading: false,
                        ageList: updatePayload
                    };
                case 39:
                    return {
                        ...state,
                        loading: false,
                        currencyList: updatePayload
                    };
                case 13:
                    return {
                        ...state,
                        loading: false,
                        marketList: updatePayload
                    };
                case 91:
                    return {
                        ...state,
                        loading: false,
                        dispatchThrough: updatePayload
                    };
                case 92:
                    return {
                        ...state,
                        loading: false,
                        dispatchMode: updatePayload
                    };
                case 95: {
                    return {
                        ...state,
                        loading: false,
                        wasteItem: updatePayload
                    };
                }
                case 23:
                    return {
                        ...state,
                        loading: false,
                        pimProgramList: updatePayload
                    };
                case 24:
                    return {
                        ...state,
                        loading: false,
                        typeOfOrder: updatePayload
                    };
                case 25:
                    return {
                        ...state,
                        loading: false,
                        typeOfPacking: updatePayload
                    };
                case 22:
                    return {
                        ...state,
                        loading: false,
                        unitOfMeasurement: updatePayload
                    };
                case 96: {
                    return {
                        ...state,
                        loading: false,
                        LotItem: updatePayload
                    };
                }
                case 43:
                    return {
                        ...state,
                        loading: false,
                        accessoriesName: updatePayload
                    };
                case 47:
                    return {
                        ...state,
                        loading: false,
                        size: updatePayload
                    };

                case 65:
                    return {
                        ...state,
                        loading: false,
                        generalheader: updatePayload
                    };
                case 66:
                    return {
                        ...state,
                        loading: false,
                        generalItem: updatePayload
                    };
                case 69:
                    return {
                        ...state,
                        loading: false,
                        dyeingProgram: updatePayload
                    };
                case 72:
                    return {
                        ...state,
                        loading: false,
                        dyeingProcess: updatePayload
                    };

                case 19:
                    return {
                        ...state,
                        loading: false,
                        sleeveType: updatePayload
                    };
                case 11:
                    return {
                        ...state,
                        loading: false,
                        neckList: updatePayload
                    };
                case 20:
                    return {
                        ...state,
                        loading: false,
                        typeOfFit: updatePayload
                    };
                case 15:
                    return {
                        ...state,
                        loading: false,
                        yarnList: updatePayload
                    };
                case 17:
                    return {
                        ...state,
                        loading: false,
                        fabricList: updatePayload
                    };
                case 52:
                    return {
                        ...state,
                        loading: false,
                        typeOfPO: updatePayload
                    };
                case 46:
                    return {
                        ...state,
                        loading: false,
                        source: updatePayload
                    };
                case 28:
                    return {
                        ...state,
                        loading: false,
                        department: updatePayload
                    };
                case 86: {
                    return {
                        ...state,
                        loading: false,
                        paymentTerms: updatePayload
                    };
                }
                case 89: {
                    return {
                        ...state,
                        loading: false,
                        catName: updatePayload
                    }
                }
                case 88: {
                    return {
                        ...state,
                        loading: false,
                        MultiList: updatePayload
                    };
                }
                case 53:
                    return {
                        ...state,
                        loading: false,
                        deliveryAt: updatePayload
                    };
                case 57:
                    return {
                        ...state,
                        loading: false,
                        agentName: updatePayload
                    };
                case 58:
                    return {
                        ...state,
                        loading: false,
                        millName: updatePayload
                    };
                case 59:
                    return {
                        ...state,
                        loading: false,
                        printType: updatePayload
                    };
                case 18:
                    return {
                        ...state,
                        loading: false,
                        diaList: updatePayload
                    };
                case 21:
                    return {
                        ...state,
                        loading: false,
                        partNameList: updatePayload
                    };
                case 10:
                    return {
                        ...state,
                        loading: false,
                        prodCategory: updatePayload
                    };
                case 67:
                    return {
                        ...state,
                        loading: false,
                        accTypeList: updatePayload
                    };
                case 68:
                    return {
                        ...state,
                        loading: false,
                        colorShadeList: updatePayload
                    };
                case 63:
                    return {
                        ...state,
                        loading: false,
                        modeOfPayment: updatePayload
                    };
                case 62:
                    return {
                        ...state,
                        loading: false,
                        paymentToBeDoneTo: updatePayload
                    };
                case 7:
                    return {
                        ...state,
                        loading: false,
                        genderList: updatePayload
                    };
                case 35:
                    return {
                        ...state,
                        loading: false,
                        productType: updatePayload
                    };
                case 80:
                    return {
                        ...state,
                        loading: false,
                        yarnMaterial: updatePayload
                    };
                case 84: {
                    return {
                        ...state,
                        loading: false,
                        gauguList: updatePayload
                    };
                }
                case 85: {
                    return {
                        ...state,
                        loading: false,
                        loopLengthOne: updatePayload
                    };
                }
                case 99:
                    return {
                        ...state,
                        loading: false,
                        adminCategory: updatePayload
                    };
                case 100:
                    return {
                        ...state,
                        loading: false,
                        companyList: updatePayload || []
                    };
                default:
                    return { ...state, loading: false };
            }
        case CREATE_COMMON_FEEDBACK_SUCCESS:
            return {
                ...state,
                loading: false,
                commonFeedbackform: {}
            };
        case APP_LOGOUT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case APP_FORCE_LOGOUT_SUCCESS:
            return {
                ...state,
                loading: false,
                isForceLogout: false
            };
        case CREATE_COMMON_PROPERTY_FAILURE:
        case APP_LOGOUT_FAILURE:
        case APP_FORCE_LOGOUT_FAILURE:
        case CREATE_COMMON_STYLE_FAILURE:
        case CREATE_COMMON_FORMAT_FAILURE:
        case FETCH_COMMON_PROPERTY_BY_ID_FAILURE:
        case FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE:
        case CREATE_COMMON_FEEDBACK_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMMON_PROPERTY:
            return {
                ...state,
                loading: false,
                commonPropertyUserform: {
                    ...state.commonPropertyUserform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_COMMON_STYLE:
            return {
                ...state,
                loading: false,
                commonStyleUserform: {
                    ...state.commonStyleUserform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_COMMON_FORMAT:
            return {
                ...state,
                loading: false,
                commonFormatUserform: {
                    ...state.commonFormatUserform,
                    [payload.key]: payload.value
                }
            };
        case SET_SINGLE_ROW_CLICK_ID:
            return {
                ...state,
                loading: false,
                singleRowData: payload
            };
        case SET_FORCE_LOGOUT_VAR:
            return {
                ...state,
                isForceLogout: payload
            };
        case RESET_SINGLE_ROW_CLICK_ID:
            return {
                ...state,
                singleRowData: {}
            };
        case COMMON_PROPERTY_USERFORM_RESET:
            return {
                ...state,
                commonPropertyUserform: {}
            };
        case COMMON_STYLE_USERFORM_RESET:
            return {
                ...state,
                commonStyleUserform: {}
            };
        case COMMON_FORMAT_USERFORM_RESET:
            return {
                ...state,
                commonFormatUserform: {}
            };
        case CREATE_COMMON_FEEDBACK_FORM:
            return {
                ...state,
                loading: false,
                commonFeedbackform: {
                    ...state.commonFeedbackform,
                    [payload.key]: payload.value
                }
            };
        case COMMON_FEEDBACK_USERFORM_RESET:
            return {
                ...state,
                commonFeedbackform: {}
            };
        case COMMON_APPROVALMAIL_USERFORM:
            return {
                ...state,
                approvalmail: {}
            };
        default:
            return state;
    }
};
